import { graphql } from 'react-apollo';
import get from 'lodash/get';
import { getAssessmentGroupInfo } from 'chameleon-src/queries';

const withAssessmentGroupInfo = graphql(getAssessmentGroupInfo, {
  options: (props) => ({
    notifyOnNetworkStatusChange: true,
    variables: {
      id: props.itemId || get(props, 'assignment.item.id'),
      assignmentId: props.assignment && get(props, 'assignment.id'),
    },
  }),
  skip: ({ isFinalExam }) => !isFinalExam,
  props: ({ data, ownProps: { setAssessmentGroup } }) => {
    const { loading, error, assessmentGroupInfo } = data;
    let errorResponse = {};

    if (error) {
      errorResponse = {
        graphQLError: error,
      };
    }

    if (assessmentGroupInfo && typeof setAssessmentGroup === 'function') {
      // NOTE: this gets narrowed down if the group has "unit" members (e.g. Pre-AP WH&G)
      //       in the AssignmenForm when the user clicks checkboxes,
      //       if this gets called again the members may reset to not be narrowed.
      //       As of 2019-11-19 there's not a place where this can happen.
      // a hacky request animation to defer this call because apparently graphql calls happen during render
      // for some reason?
      requestAnimationFrame(() => setAssessmentGroup(assessmentGroupInfo));
    }

    return {
      isGraphQLLoading: loading,
      assessmentGroupInfo,
      ...errorResponse,
    };
  },
});

export { withAssessmentGroupInfo };
